// Some browsers / SVG combinations (no intrinsic size, or width/height set via
// units the parser doesn't honor at decode time) hand us an Image with width=0
// and height=0 — drawImage runs silently, but canvas.toBlob returns null. Parse
// the SVG attributes directly so we always have non-zero dimensions to work with.
const parseSvgDimensions = (svgCode) => {
    const widthMatch = svgCode.match(/<svg\b[^>]*\bwidth\s*=\s*"([^"]+)"/i);
    const heightMatch = svgCode.match(/<svg\b[^>]*\bheight\s*=\s*"([^"]+)"/i);
    const w = widthMatch ? parseFloat(widthMatch[1]) : NaN;
    const h = heightMatch ? parseFloat(heightMatch[1]) : NaN;
    if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) return {w, h};

    const viewBoxMatch = svgCode.match(/<svg\b[^>]*\bviewBox\s*=\s*"([^"]+)"/i);
    if (viewBoxMatch) {
        const parts = viewBoxMatch[1].trim().split(/[\s,]+/).map(parseFloat);
        if (parts.length === 4 && parts.every(Number.isFinite) && parts[2] > 0 && parts[3] > 0) {
            return {w: parts[2], h: parts[3]};
        }
    }
    return null;
};

export function makePngFromSvg(svgCode) {
    return new Promise((resolve, reject) => {

        const svgImage = new Image();
        svgImage.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgCode)}`;

        svgImage.onload = () => {
            let width = svgImage.width;
            let height = svgImage.height;

            if (!width || !height) {
                const parsed = parseSvgDimensions(svgCode);
                if (parsed) {
                    width = parsed.w;
                    height = parsed.h;
                }
            }

            if (!width || !height) {
                reject(new Error(`makePngFromSvg: SVG has zero/unknown dimensions (image=${svgImage.width}x${svgImage.height}); likely the text rendered no glyphs (missing font or empty content).`));
                return;
            }

            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');

            canvas.width = width;
            canvas.height = height;

            context.drawImage(svgImage, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve({

                        imgUrl: URL.createObjectURL(blob),
                        blob: blob,
                        width: canvas.width,
                        height: canvas.height,

                    });
                } else {
                    reject(new Error(`makePngFromSvg: canvas.toBlob returned null at ${canvas.width}x${canvas.height}.`));
                }
            }, 'image/png');

        };

        svgImage.onerror = (error) => {
            console.error("Error loading SVG", error);
            reject(new Error("Error loading SVG"));
        };
    });
}